import React from 'react';
import { motion } from 'framer-motion';
import { Globe, TrendingUp } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide08Expansion({
  index
}: SlideProps) {
  return <InteriorSlide banner={<SlideBanner eyebrow="The Math" data-id="element-165">
          Running 4 brands? That's 16 campaigns per year at €1,000 per campaign
          with reducing campaign costs per country and increased ROI on the
          Master Snak for each country that is onboarded.
        </SlideBanner>} data-id="element-164">
      <SlideHeader eyebrow="Scalability" data-id="element-166">Campaign Adaptation</SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full gap-12" data-id="element-167">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-168">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="bg-[var(--brand)] text-white rounded-3xl p-12 text-center shadow-xl flex-1 w-full" data-id="element-169">
            <div className="text-sm font-bold uppercase tracking-widest opacity-80 mb-2" data-id="element-170">
              Per Country
            </div>
            <div className="text-6xl font-extrabold mb-4" data-id="element-171">€900</div>
            <p className="text-lg opacity-90" data-id="element-172">
              campaign adaptation for scalable parallel country deployments
            </p>
          </motion.div>

          <div className="flex-1 space-y-6 w-full" data-id="element-173">
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.5,
            duration: 0.5
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-black/5 flex items-start gap-4" data-id="element-174">
              <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)] flex-shrink-0" data-id="element-175">
                <Globe className="h-5 w-5" data-id="element-176" />
              </div>
              <div data-id="element-177">
                <h3 className="font-bold text-[var(--fg)] mb-1" data-id="element-178">
                  Parallel Deployments
                </h3>
                <p className="text-sm text-[var(--muted)]" data-id="element-179">
                  Easily roll out the same core campaign across multiple African
                  markets.
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.6,
            duration: 0.5
          }} className="bg-white p-6 rounded-2xl shadow-sm border border-black/5 flex items-start gap-4" data-id="element-180">
              <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)] flex-shrink-0" data-id="element-181">
                <TrendingUp className="h-5 w-5" data-id="element-182" />
              </div>
              <div data-id="element-183">
                <h3 className="font-bold text-[var(--fg)] mb-1" data-id="element-184">
                  Increased ROI
                </h3>
                <p className="text-sm text-[var(--muted)]" data-id="element-185">
                  The initial Master Snak investment pays off more with every
                  new country onboarded.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </InteriorSlide>;
}